import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Utils } from '../../../../core/utils/utils';
import { STORAGE, PETICIONES } from 'src/app/core/utils/constants';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { CarpTipusAvisos } from 'src/app/core/entities/carptipusavisos.model';
import { CarpTipusCarpeta } from 'src/app/core/entities/carptipuscarpeta.model';
import { CarpAvisosTer } from 'src/app/core/entities/carpavisoster.model';
import { TokenValid } from 'src/app/core/auth/tokenvalid.model';
import * as _ from 'lodash';

@Injectable()
export class DialogsAvisosService {

    carpTipusAvisos: CarpTipusAvisos[] = new Array<CarpTipusAvisos>();
    carpTipusAvisosTrue: CarpTipusAvisos[] = new Array<CarpTipusAvisos>();
    carpTipusAvisosTrueOrig: CarpTipusAvisos[] = new Array<CarpTipusAvisos>();
    carpTipusAvisosTipo: CarpTipusAvisos[] = new Array<CarpTipusAvisos>();
    datosForm = new Array<CarpTipusAvisos>();

    carpTipusCarpeta: CarpTipusCarpeta[] = new Array<CarpTipusCarpeta>();

    carpAvisosTer: CarpAvisosTer[] = new Array<CarpAvisosTer>();
    carpAvisosTerSave: CarpAvisosTer[] = new Array<CarpAvisosTer>();

    titulo: string = "";
    validToken: TokenValid = new TokenValid();

    constructor(private repositoryService: RepositoryService) { }

    init(datos: any): Observable<any> {

        let stringToken = localStorage.getItem(STORAGE.VALID_TOKEN) ?? "";
        this.validToken = JSON.parse(stringToken);

        this.carpTipusAvisosTrue = [];
        this.carpTipusAvisosTipo = [];

        return forkJoin([this.repositoryService.doGet(PETICIONES.carpTipusAvisos.findAll),
                        this.repositoryService.doGet(PETICIONES.carpTipusCarpeta.findAll),
                        this.repositoryService.findByCode(PETICIONES.carpAvisosTer.getByIdentifTer, this.validToken.identifier)])
            .pipe(map(dataGroup => {

                this.carpTipusAvisos = dataGroup[0];
                this.carpTipusCarpeta = dataGroup[1];
                this.carpAvisosTer = dataGroup[2];

                for (let i = 0; i < this.carpTipusCarpeta.length; i++) {
                    if (this.carpTipusCarpeta[i].codi === datos.tipocarpeta) {
                        this.titulo = this.carpTipusCarpeta[i].descripcio;
                    }
                }

                let originalcarpTipusAvisos = new Array<CarpTipusAvisos>();
                originalcarpTipusAvisos = _.cloneDeep(this.carpTipusAvisos);

                // Sacamos todos los carp_tipus_avisos de en el TIPOCARPETA correspondiente
                for (let i = 0; i < originalcarpTipusAvisos.length; i++) {
                    if (originalcarpTipusAvisos[i].codiTipusCarpeta === datos.tipocarpeta) {
                        this.carpTipusAvisosTipo.push(originalcarpTipusAvisos[i]);
                    }
                }

                if (this.carpAvisosTer.length > 0) {

                    for (let i = 0; i < this.carpTipusAvisosTipo.length; i++) {
                        for (let x = 0; x < this.carpAvisosTer.length; x++) {
                            if (this.carpTipusAvisosTipo[i].id === this.carpAvisosTer[x].carpAvisosTerPK.tipusAvisId &&
                                this.carpAvisosTer[x].carpAvisosTerPK.identificadorTer === this.validToken.identifier) {
                                this.carpTipusAvisosTipo[i].actiu = this.carpAvisosTer[x].actiu;
                            }
                            if(this.carpTipusAvisosTipo[i].actiu == null){
                                this.carpTipusAvisosTipo[i].actiu = false;
                            }
                        }
                    }

                } else {
                    for (let i = 0; i < this.carpTipusAvisosTipo.length; i++) {
                        this.carpTipusAvisosTipo[i].actiu = false;
                    }
                }

                for (let i = 0; i < this.carpTipusAvisosTipo.length; i++) {
                    if (this.carpTipusAvisosTipo[i].codiTipusCarpeta === datos.tipocarpeta && this.carpTipusAvisosTipo[i].enabled === true) {
                        this.carpTipusAvisosTrue.push(this.carpTipusAvisosTipo[i]);
                    }
                }

                this.carpTipusAvisosTrueOrig = _.cloneDeep(this.carpTipusAvisosTrue);

                return this.carpTipusAvisosTrue;
            }),catchError((error: any) => {
                console.log(error);
                throw error;
            }));
    }

    /**
    * @description
    * Recoge los avisos modificados y los guarda en base de datos; tras carga, vuelve a mostrar los datos actualizados
    * @param data avisos modificados por el usuario.
    */
    gestionAvisos(data: CarpTipusAvisos[]) {

        this.carpAvisosTerSave = [];

        let chivato : boolean = false;
        let avisos = new Array<CarpAvisosTer>();
        avisos = _.cloneDeep(this.carpAvisosTer);

        //si chivato sale true: no insertamos; solo modificamos data y actiu de los valores
        for (let i = 0; i < avisos.length; i++) {
            for (let x = 0; x < data.length; x++) {
                if(avisos[i].carpAvisosTerPK.tipusAvisId == data[x].id){
                    chivato = true;
                }
            }
        }

        //Si no tenemos ningún aviso que pertenezca al rol seleccionado
        if (chivato == false) {
            let objetAviso = new CarpAvisosTer();
            //iteramos todos los avisos modificados por el usuario Formulario
            for (let i = 0; i < data.length; i++) {
                //vamos insertando los avisos del formulario en su usuario correspondiente
                objetAviso.carpAvisosTerPK.tipusAvisId = data[i].id;
                objetAviso.carpAvisosTerPK.identificadorTer = this.validToken.identifier;
                if (!Utils.noUndfAndNull(data[i].actiu)) {
                    this.datosForm[i].actiu = false;
                }
                objetAviso.actiu = data[i].actiu;
                objetAviso.dataCanvi = new Date();
                //pasamos el objeto al array
                this.carpAvisosTerSave.push(objetAviso);
                //limpiamos el objeto para otra pasada
                objetAviso = new CarpAvisosTer();
            }
        }else{
            for (let i = 0; i < avisos.length; i++) {
                for (let x = 0; x < data.length; x++) {
                    if(avisos[i].carpAvisosTerPK.tipusAvisId == data[x].id){
                        if(avisos[i].actiu != data[x].actiu){
                            avisos[i].actiu = data[x].actiu;
                            avisos[i].dataCanvi = new Date();
                        }
                    }
                }
            }
            this.carpAvisosTerSave = _.cloneDeep(avisos);
        }

        return this.repositoryService.doPost(PETICIONES.carpAvisosTer.postCarpAvisosTer, this.carpAvisosTerSave)
        .pipe(map(data => {
            console.log(data);
            return true;
        }),catchError((error: any) => {
            console.log(error);
            throw error;
        }));

    }

    /**
    * @description
    * Comprueba si dos arrray CarpTipusAvisos son iguales.
    * @param datoX array CarpTipusAvisos 1
    * @param datoY array CarpTipusAvisos 2
    * @returns True si son iguales
    */
    public compare(itemX: CarpTipusAvisos[], itemY: CarpTipusAvisos[]): boolean {
        //Ambos objetos están definidos y no son nulos
        if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

            for (let i = 0; i < itemX.length; i++) {
                for (let x = 0; x < itemY.length; x++) {
                    if (itemX[i].actiu != itemY[i].actiu) {
                        return false;
                    }
                }
            }
        }
        //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
        else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
            return false;
        }
        return true;
    }

    build() {
    }
}
